import React from 'react';
import PublicPageLayout from '../../layouts/PublicPageLayout';
import Hero from '../../components/sections/welcome/Hero';
import { Stats } from '../../components/sections/welcome/Stats';
import Features from '../../components/sections/welcome/Features';
import { kafintech_products } from '../../constantes/kafintech-product';

export const LandingPage: React.FC = () => {
  return (
    <PublicPageLayout>
      <div className="min-h-screen bg-[#F8FAFC] text-slate-800 font-sans pb-12">

        {/* --- HERO SECTION --- */}
        <section className="lg:min-h-[33vh] flex items-center">
          <div className="w-full">
            <Hero />
          </div>
        </section>

        {/* --- BANDE DE STATISTIQUES --- */}
        <section className="my-6">
          <Stats />
        </section>

        {/* --- FEATURES GRID SECTION --- */}
        <section className="mb-8">
          <Features />
        </section>

        {/* --- TRUST / PARTNERS BANNER (PREMIUM) --- */}
        <section className="py-10 bg-white/70 backdrop-blur-md border-y border-slate-200/60 relative overflow-hidden">
          {/* Gradient Edges */}
          <div className="absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-white to-transparent z-10 pointer-events-none hidden sm:block" />
          <div className="absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-white to-transparent z-10 pointer-events-none hidden sm:block" />

          <div className="max-w-7xl mx-auto px-6 lg:px-12 relative z-0">
            <div className="flex flex-col items-center gap-6">
              
              {/* Badge d'en-tête */}
              <div className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-slate-100/80 border border-slate-200/60 shadow-inner">
                <span className="w-1.5 h-1.5 rounded-full bg-emerald-500 animate-pulse" />
                <span className="text-[11px] font-bold tracking-widest uppercase text-slate-500">
                  Ils nous font confiance
                </span>
              </div>

              {/* Grid de Cartes de Partenaires */}
              <div className="flex flex-wrap items-center justify-center gap-3 sm:gap-4 md:gap-5">
                {kafintech_products.map((p, index) => (
                  <div
                    key={index}
                    className="group flex items-center gap-3 px-4 py-2.5 rounded-xl bg-white border border-slate-200/80 shadow-[0_2px_8px_-2px_rgba(0,0,0,0.04)] hover:shadow-md hover:border-slate-300 hover:-translate-y-0.5 transition-all duration-300 cursor-pointer"
                  >
                    <img 
                      src={p.logo} 
                      alt={p.label} 
                      className="h-5 sm:h-6 w-auto object-contain grayscale opacity-60 group-hover:grayscale-0 group-hover:opacity-100 transition-all duration-300"
                    />
                    <span className="text-xs font-bold text-slate-600 group-hover:text-slate-900 transition-colors">
                      {p.label}
                    </span>
                  </div>
                ))}
              </div>

            </div>
          </div>
        </section>

      </div>
    </PublicPageLayout>
  );
};